import { Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useIsEInvoicingOnly } from '@features/bills/hooks/useIsEInvoicingOnly'

import { EInvoicesEmptyUnregistered } from '../../../../assets/images'
import { useEInvoicingSetup } from '../../hooks/useEInvoicingSetup'
import { EInvoicingActivatedEmptyState } from '../EInvoicingActivatedEmptyState'
import { EInvoicingGenericStatus } from '../EInvoicingGenericStatus'

export const EInvoicingKYCApproved = (): ReactElement => {
  const { t } = useTranslation()
  const { isEInvoicingActivated } = useEInvoicingSetup()
  const isEInvoicingOnly = useIsEInvoicingOnly()

  if (isEInvoicingActivated || isEInvoicingOnly) {
    return <EInvoicingActivatedEmptyState />
  }

  return (
    <EInvoicingGenericStatus
      title={t('e_invoice.kyc.step.status.approved.title')}
      illustration={EInvoicesEmptyUnregistered}
    >
      <Text colorVariant="secondary" alignment="center">
        {t('e_invoice.kyc.step.status.approved.subtitle')}
      </Text>
    </EInvoicingGenericStatus>
  )
}
